/**
 * Update Blog Post API
 *
 * Update existing blog posts in Supabase.
 * @see src/features/blog/hooks/useUpdateBlogPost.ts for React Query wrapper
 */

import { supabase } from '@/lib/supabase';
import type { BlogPost } from '../types';

/**
 * Update an existing blog post
 * Automatically updates the updated_at timestamp
 * @param id - The blog post ID to update
 * @param data - Partial BlogPost data to update
 * @returns Promise resolving to the updated BlogPost object
 */
export const updateBlogPost = async (id: string, data: Partial<BlogPost>): Promise<BlogPost> => {
  const { data: result, error } = await supabase
    .from('blog_posts')
    .update({
      ...data,
      updated_at: new Date().toISOString()
    })
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return result;
};
